export default __webpack_public_path__ + "static/media/twoStepHighKnee.4e2d5a10.png";